export {default} from './WalletInfo';
